export default __webpack_public_path__ + "static/img/pending_item_res.23b0391.svg";